import React from "react";
import axios from "axios";
import SpeakerCardSection from "./speakerCardSection";
import SpeakerModal from "./speakerModal";
import Element from '../../basic/element';
import "./speakerSection.scss";

// =====================================================================================================
// Main class for sending Ajax calls and pass data down to lower order components
// =====================================================================================================
class SpeakerSection extends React.Component {
    constructor(props) {
        super(props);

        const { srcUrl, agendaSheetId, compact, errorMessage } = this.props.config;

        this.state = {
            speakers: null,
            speaker: null,
            errorMessage: null
        };

        this.onOpenSpeaker = this.onOpenSpeaker.bind(this);
        this.onCloseSpeaker = this.onCloseSpeaker.bind(this);
    }

    // =====================================================================================================
    // Main class for sending Ajax calls and pass data down to lower order components
    // =====================================================================================================
    componentDidMount() {
        this.fetchFullSpeaker();
    }

    render() {
        const content = this.renderContent();
        // =====================================================================================================
        // Render speaker modal if a speaker have been clicked. Otherwise return null
        // =====================================================================================================
        const speakerModal = this.state.speaker ?
            <SpeakerModal data={this.state.speaker} onClose={this.onCloseSpeaker} /> : null;

        return (
            <section id={"pubhub-speaker-widget"}>
                <div className='container'>
                    <div className="row row-centered">
                        {this.props.config.title !== "" ?
                            <h1 className="speaker-list section-header-line">{this.props.config.title}</h1> : ""}
                    </div>
                    {content}
                </div>
                {speakerModal}
            </section>
        );
    }

    // =====================================================================================================
    // Filter speaker by type, if no condition then will return all speakers
    // =====================================================================================================
    filterByType(data) {
        let speakerArray = data;
        let tempArray = [];
        speakerArray.forEach((item, index) => {
            if (item.type === this.props.config.speakerType) {
                tempArray.push(item);
            }
        });

        return tempArray;
    }

    // =====================================================================================================
    // Filter speaker by weight, if no condition then will return all speakers
    // =====================================================================================================
    sortByKey(key, data) {
        if (data.length == 0) {
            return data;
        }
        let speakerArray = data;
        let weightedArray = [];
        key = key.toLowerCase();
        // =====================================================================================================
        // First extract all speakers with weight and store them separately by reverse traversing it
        // =====================================================================================================
        if (speakerArray[0].hasOwnProperty(key)) {
            for (let i = speakerArray.length - 1; i >= 0; i--) {
                if (speakerArray[i][key] !== 0) {
                    weightedArray.push(speakerArray[i]);
                    speakerArray.splice(i, 1);
                }
            }
        }


        // =====================================================================================================
        // Sort the remaining array alphabetically
        // =====================================================================================================
        let resultArray = speakerArray.sort((itemA, itemB) => {
            if (itemA.fullName < itemB.fullName) {
                return -1;
            }
            if (itemA.fullName > itemB.fullName) {
                return 1;
            }
            return 0;
        });

        // =====================================================================================================
        // Sort the weighted array by weight
        // =====================================================================================================
        let sortedArray = weightedArray.sort((itemA, itemB) => {
            if (itemA[key] > itemB[key]) {
                return -1;
            }
            if (itemA[key] < itemB[key]) {
                return 1;
            }
            // a must be equal to b
            return 0;
        });
        // =====================================================================================================
        // Insert sorted weight array back to the remaining array's head by reverse traversing it
        // =====================================================================================================
        for (let i = sortedArray.length - 1; i >= 0; i--) {
            resultArray.unshift(sortedArray[i]);
        }
        return resultArray;
    }


    // =====================================================================================================
    // Render spinner if there is no data, otherwise render speaker cards and pass down the onOpen handler
    // =====================================================================================================
    renderContent() {
        if (this.state.errorMessage) {
            return (
                <div className='error-container'>
                    <div className='err-msg-area'>
                        <div className='err-msg-content'>
                            <Element className='err-msg' data={this.state.errorMessage} />
                        </div>
                    </div>
                </div>
            );
        }

        if (!this.state.speakers) {
            return <div className='loading-container'>
                <div className='pubhub-loading'></div>
            </div>
        }

        return (
            <SpeakerCardSection data={this.state.speakers} speakerClickHandler={this.onOpenSpeaker} />
        );
    }

    // =====================================================================================================
    // On open handler used to handle click on a speaker card
    // =====================================================================================================
    onOpenSpeaker = (speakerClicked) => {
        let speakerModalInfo = null;

        for (let i = 0; i <= this.state.speakers.length; i++) {
            let object = this.state.speakers[i];
            if (object.fullName === speakerClicked) {
                if (object.biography) {
                    speakerModalInfo = object;
                }
                break;
            }
        }

        if (speakerModalInfo) {
            this.setState({ speaker: speakerModalInfo });
        }
    };

    // =====================================================================================================
    // On close handler used to handle closing of a speaker modal
    // =====================================================================================================
    onCloseSpeaker = () => {
        this.setState({ speaker: null });
    };

    // =====================================================================================================
    // Building the ajax url with config file
    // =====================================================================================================
    buildDataSrcUrl(config) {
        return config.srcUrl || `${config.srcBaseUrl}${config.speakerDataId}/data.json`;
    }

    // =====================================================================================================
    // Sending ajax call to get speaker data, also apply filtering once the data is received
    // =====================================================================================================
    fetchFullSpeaker() {
        const { config } = this.props;
        const srcUrl = this.buildDataSrcUrl(config);
        axios.get(srcUrl).then((response) => {
            this.setSpeakers(response);
        })
        .catch(error => {
            const message = this.getRegisterInfo();
            this.setState({ errorMessage: message });

            this.registerJsonData(config.speakerDataId)
        })
    }

    setSpeakers(response) {
        let data = response.data;
        // =====================================================================================================
        // If the config speaker type is not undefined
        // =====================================================================================================
        data = this.filterByType(data);


        // =====================================================================================================
        // If the config sort by is not undefined and equal to weight
        // =====================================================================================================
        if (this.props.config.sortBy !== '') {
            data = this.sortByKey(this.props.config.sortBy, data);
        }
        this.setState({ speakers: data });
    }

    getRegisterInfo() {
        const { registerMessage } = this.props.config;
        return registerMessage || `Initializing data ...`;
    }

    registerJsonData(speakerId) {
        const data = { speakerId };

        axios.post(this.buildRegisterUrl(), data)
            .then(() => {
                setTimeout(() => {
                    this.props.forceRefresh && this.props.forceRefresh();
                }, 3000);
            })
            .catch(error => {
                this.setState({
                    errorMessage: this.props.config.errorMessage.status
                });
            })
    }

    buildRegisterUrl() {
        if (this.props.config.registerUrl) return this.props.config.registerUrl;

        return PubHub.APIHost + "/v1/agendawidget/agendas/register";
    }
}

export default SpeakerSection;
